import React from 'react';
import { Redirect } from 'react-router-dom';
import { updateAuthorized, verifyToken, showLoading, fetchBillingDetails, fetchOptions, fetchUser, fetchSurveyStatus } from '../redux/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { UNIFORM_RESOURCE_LOCATORS } from '../utils/constants';
import { isLandlordLoggedIn } from '../utils/AuthUtils';
import { CustomLocalStorage, TOKEN_KEYS } from '../utils/customStorage';
import { IonLoading } from '@ionic/react';
import _ from 'lodash';
import * as PermChecker from "../utils/PermUtils";

const mapStateToProps = state => {
    return {
        authorized: state.authorized,
        finishedAuthCheck: state.finishedAuthCheck,
        billing: state.billing,
        survey: state.survey,
        options: state.options,
        user: state.user
    };
}

const mapDispatchToProps = {
    updateAuthorized,
    verifyToken,
    showLoading,
    fetchBillingDetails,
    fetchOptions,
    fetchUser,
    fetchSurveyStatus
};


class ProtectedRoute extends React.Component {

    constructor(props){
        super(props);
    }

    fetchInitialData = async () => {
        if (_.isEmpty(this.props.billing)){
            await this.props.fetchBillingDetails();
        }
        if (_.isEmpty(this.props.survey)){
            await this.props.fetchSurveyStatus();
        }
        if (_.isEmpty(this.props.options)){
            await this.props.fetchOptions();
        }
            await this.props.fetchUser();
    };

    async componentDidMount () {
        await this.fetchInitialData();
        await this.checkAuthStatus();
        const access = await CustomLocalStorage.getItem(TOKEN_KEYS.ACCESS);
        const refresh = await CustomLocalStorage.getItem(TOKEN_KEYS.REFRESH);
        if (!access || !refresh) {
            this.props.updateAuthorized(false);
        }
    }

    async checkAuthStatus(){
        if (!this.props.authorized){
            this.props.showLoading(true);
            await this.props.verifyToken();
            this.props.showLoading(false);
        }
    }

    render() {

        const Component = this.props.component;
        if (!isLandlordLoggedIn()){
            return <Redirect to={{ pathname: UNIFORM_RESOURCE_LOCATORS.appLogin, redirectTo: this.props.location.pathname }} />
        }
        if (this.props.finishedAuthCheck){
            // If a user hasn't paid, redirect them to subscription-expired page
            if (this.props.billing && this.props.billing.customerAccount){
                const customerAccount = this.props.billing.customerAccount;
                // if customer has negotiated payment date in the future then allow them to access the app
                const hasCustomerNegotiatedToPayLater = (
                    customerAccount.negotiatedPaymentDeadline &&
                    new Date(customerAccount.negotiatedPaymentDeadline) >= new Date()
                )

                // redirect to subscription expired page if customer hasn't negotiated to pay later and
                // their subscription balance is greater than zero
                let pathsToExempt = [UNIFORM_RESOURCE_LOCATORS.subscriptionExpired, UNIFORM_RESOURCE_LOCATORS.billing];
                if (!hasCustomerNegotiatedToPayLater && customerAccount.subscriptionBalance > 0 && !pathsToExempt.includes(this.props.location.pathname)){
                    return <Redirect to={UNIFORM_RESOURCE_LOCATORS.subscriptionExpired} />;
                }
            }


            // Enforce permission checks for relevant models
            if (this.props.authorized){
                if (this.props.survey && this.props.survey.isSurveyCompleted === false && this.props.location.pathname !== UNIFORM_RESOURCE_LOCATORS.survey){
                    return <Redirect to={UNIFORM_RESOURCE_LOCATORS.survey} />;
                }

                const pageToAccess = this.props.location.pathname;

                if(PermChecker.PAGES_TO_CHECK.includes(pageToAccess)){
                    let model = PermChecker.URL_MODEL_PERM_MAP[pageToAccess].model;
                    let perm = PermChecker.URL_MODEL_PERM_MAP[pageToAccess].perm;
                    let userPermissions = this.props.options.userPermissions;
                    let hasPerm = PermChecker.checkUserHasPermission(model, perm, userPermissions);
                    if(!hasPerm){
                        return <Redirect to= {UNIFORM_RESOURCE_LOCATORS.dashboard}/>
                    }
                }


                return <Component tab={this.props.tab} />

            }else{
                return <Redirect to={{ pathname: UNIFORM_RESOURCE_LOCATORS.appLogin, redirectTo: this.props.location.pathname }} />
            }
        } else {

            return this.props.authorized? (
                <Component />
            ) : (
                <IonLoading isOpen={true}  message={'Loading...'}/>
            );
        }

    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ProtectedRoute));